export default class MediaManager {

    constructor() {

        this.media = 'phone';

        this.widthDictionary = {
            phone: '(min-width : 320px) and (max-width : 640px)',
            phablet: '(min-width : 641px) and (max-width : 767px)',
            tablet: '(min-width : 768px) and (max-width : 1024px)',
            pc: '(min-width : 1224px) and (max-width : 1823px)',
            pcLarge: '(min-width : 1824px)'
        }

        this.mediaCallback = () => { }

        this.testMedia = this.testMedia.bind(this);
        this.getMediaInfo = this.getMediaInfo.bind(this);
        this.isPhone = this.isPhone.bind(this);
        this.phoneListener = this.phoneListener.bind(this);

        this.getMediaInfo();

        this.phoneQuery = window.matchMedia('(max-width : 767px)');
        this.phoneQuery.addListener(this.phoneListener);
    }

    testMedia(media) {
        return window.matchMedia(media).matches;
    }

    getMediaInfo() {
        Object.keys(this.widthDictionary).forEach((key) => {
            if (this.testMedia(this.widthDictionary[key])) {
                if (key != this.media) {
                    this.media = key;
                }
            }
        });

        return this.media;
    }

    isPhone() {
        let media = this.getMediaInfo();

        return (media === 'phone' || media === 'phablet');
    }

    phoneListener(mediaEvent) {

        this.getMediaInfo();
        if (this.mediaCallback) {
            this.mediaCallback((this.media === 'phone' || this.media === 'phablet'));
        }
    }
}